import { Content, ContentHeader, Table, TableBody, TableCell, TableHead, TableRow } from 'src/app/components'
import { WinnerModel, WinnersModel } from 'src/app/modules/campaign/models/LuckyDraw.model'

import dayjs from 'dayjs'

export interface TabWinnerGrandPrizeProps {
    data?: WinnersModel
}

export default function TabWinnerGrandPrize({ data }: TabWinnerGrandPrizeProps) {

    const renderItem = (item: WinnerModel, index: number) => {
        return (
            <TableRow key={item.id}>
                <TableCell {...{ index }} />
                <TableCell value={item?.member?.member_code} />
                <TableCell value={item?.member?.fullname} />
                <TableCell value={item?.member?.phone_number} />
                <TableCell value={item?.member?.email} />
                <TableCell
                    renderValue={(_) => dayjs(_).format('DD/MM/YYYY')}
                    className="w-[145px]"
                    value={item?.draw_date}
                />
                <TableCell value={item?.draw_directory?.directory_name} />
            </TableRow>
        )
    }

    return (
        <Content>
            <ContentHeader title={data?.name || ''} />

            <div className="px-8">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell index />
                            <TableCell>Customer ID</TableCell>
                            <TableCell>Customer Name</TableCell>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Draw Date</TableCell>
                            <TableCell>Draw Location</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.data?.map(renderItem)}
                    </TableBody>
                </Table>
            </div>
        </Content>
    )
}
